import React from 'react';
import moment from 'moment/moment';
import * as S from '../styles';
import LogoWithTrademark from '#app/components/LogoWithTrademark';
import { routes } from '#app/constants/routes';

const FooterSection = ({ i18n, onAgreementClick, onPolicyClick }) => {
  return (
    <S.Footer>
      <S.Wrap>
        <S.FooterLeft>
          <LogoWithTrademark variant="alternate" to={routes.ROOT} />
        </S.FooterLeft>
        <S.FooterRight>
          <div className="footer-email">
            <a id="support" href="mailto:info@whiteswan.finance">
              info@whiteswan.finance
            </a>
          </div>
          <div className="footer-phone">
            <a href="tel:+79807056611">+7 980 705 66 11</a>
          </div>
        </S.FooterRight>
      </S.Wrap>

      <S.Wrap>
        <S.FooterLeft>
          <div className="footer-copyright">
            {i18n.mainPage.company}, {moment().format('YYYY')}
            <br />
            {i18n.mainPage.inn}
            <br />
            <div>
              <a href="/agreement/" onClick={onAgreementClick}>
                {i18n.mainPage.agreement}
              </a>
            </div>
            <div>
              <a href="/policy/" onClick={onPolicyClick}>
                {i18n.mainPage.politic}
              </a>
            </div>
          </div>
        </S.FooterLeft>
        <S.FooterRight>
          <div />
        </S.FooterRight>
      </S.Wrap>
    </S.Footer>
  );
};

export default FooterSection;
